import { jsx as e } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 19.75C3.25736 19.75 2.25 18.7426 2.25 17.5V9.75L21.75 9.75V17.5C21.75 18.7426 20.7426 19.75 19.5 19.75L4.5 19.75ZM21.75 8.25V6.5C21.75 5.25736 20.7426 4.25 19.5 4.25H4.5C3.25736 4.25 2.25 5.25736 2.25 6.5V8.25L21.75 8.25ZM6 11.2C6 11.0895 6.08954 11 6.2 11H8.8C8.91046 11 9 11.0895 9 11.2V12.8C9 12.9105 8.91046 13 8.8 13H6.2C6.08954 13 6 12.9105 6 12.8V11.2Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
